import http from '@/core/http'

const state = {
  items: {}
}

const actions = {
  getItens: async ({ commit },payload) => {
    const headers = { moduloname: 'afiliados' }
    const result = await http.get('pixel', { params: payload, headers })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  salvar: async (_, payload) => {
    const result = await http.post('pixel', payload)
    return Promise.resolve(result)
  },
}

const mutations = {
  'LISTA_ITENS' (state, payload) {
    state.items = {
      idPixel: payload.data.idPixel
    }
  },
}

const getters = {
  items: state => state.items,
}

export default { namespaced: true, state, actions, mutations, getters }